import { AdvisorNote } from '#ui/AdvisorNote.js';
import { SimpleMarkdown } from '#ui/chat/SimpleMarkdown.js';
import { SectionDivider } from '#ui/SectionDivider.js';

import { DetailRow } from './ItineraryDetailRow.js';

interface ItineraryNotesSectionProps {
  notes?: string | null;
  advisorNote?: string | null;
  /** When provided, the notes row becomes clickable (or an "Add note" row appears). */
  onEditNote?: () => void;
}

export function ItineraryNotesSection({ notes, advisorNote, onEditNote }: ItineraryNotesSectionProps) {
  if (!notes && !onEditNote && !advisorNote) return null;

  return (
    <div className="flex flex-col text-sm">
      <SectionDivider label="Notes" className="mb-2" />
      {notes ? (
        <DetailRow
          icon="sticky_note_2"
          value={<SimpleMarkdown text={notes} />}
          onClick={onEditNote}
          tooltip={onEditNote ? 'Edit note' : undefined}
        />
      ) : (
        onEditNote && (
          <DetailRow
            icon="sticky_note_2"
            trailingIcon="edit"
            value="Add note"
            onClick={onEditNote}
            className="text-muted-foreground"
          />
        )
      )}
      {advisorNote && <AdvisorNote text={advisorNote} />}
    </div>
  );
}
